<template>
  <div>...</div>
</template>

<script>
export default {
  name: "PreloadLayout",
};
</script>
